import { Component, input } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { DatePipe } from '@lx/shared/ui/pipes';
import { DateFormat } from '@lx/shared/i18n';

@Component({
  standalone: true,
  selector: 'lx-next-steps',
  templateUrl: './next-steps.component.html',
  styleUrls: ['./next-steps.component.scss'],
  imports: [CommonModule, DatePipe, NgOptimizedImage],
})
export class NextStepsComponent {
  courseStartDate = input.required<Date>();

  protected readonly DateFormat = DateFormat;
}
